import { expand } from 'uri-template-lite';

import { apiClient } from '../../common/ApiClient';
import { DataSubjectUrl } from './DataSubjectUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';

export const updateFromMyr = (code?: string) =>
  apiClient
    .post(expand(DataSubjectUrl.DATASUBJECT_UPDATE_FROM_MYR, { code }))
    .then((response) => response.data);

export const useDataSubjectUpdateFromMyr = createApiQueryHook(
  ['data_subject_myr'],
  updateFromMyr
);
